import { render } from "./ContactDetails.vue?vue&type=template&id=6b87d1b4&scoped=true&ts=true"
import script from "./ContactDetails.vue?vue&type=script&lang=ts"
export * from "./ContactDetails.vue?vue&type=script&lang=ts"

import "./ContactDetails.vue?vue&type=style&index=0&id=6b87d1b4&scoped=true&lang=css"

import exportComponent from "/tmp/nginx/vue-single-page-app/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-6b87d1b4"]])

export default __exports__